import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/exchange-rates', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCurrency = (Options = {}) => {
  return httpClient
    .get('/api/exchange-rates/currencies', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/exchange-rates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, getCurrency }
